import { render, staticRenderFns } from "./PaymentsAndCurrenciesPayments.vue?vue&type=template&id=e3839c5c&scoped=true&"
import script from "./PaymentsAndCurrenciesPayments.vue?vue&type=script&lang=js&"
export * from "./PaymentsAndCurrenciesPayments.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsAndCurrenciesPayments.vue?vue&type=style&index=0&id=e3839c5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3839c5c",
  null
  
)

export default component.exports